function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5768a8;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Icon-delete");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "spacer",
  className: "cls-1",
  width: 32,
  height: 32
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "deleteOutline",
  className: "cls-2 fill",
  d: "M23,9.06V27.92H9V9.06H23M21.5,2h-11l-1,1H6V5H26V3H22.5Zm3.5,5H7V27.92a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "deleteFill",
  className: "cls-1",
  d: "M21.5,2h-11l-1,1H6V5H26V3H22.5Zm3.5,5H7V27.92a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2Z"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.8eabe857.svg";
export { ForwardRef as ReactComponent };